import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { loadScript } from '../../utils/script/script';
import { getHandbackUrl } from '../../redux/actions/data-action-link/dataActionLinkActions';

export class Recommendations extends Component {

  static propTypes = {
    getHandbackUrl: PropTypes.func,
    handbackUrl: PropTypes.string,
    productIds: PropTypes.string,
    skuIds: PropTypes.string,
  };

  static defaultProps = {
    getHandbackUrl: window.defaultFunc,
    handbackUrl: undefined,
    productIds: undefined,
    skuIds: undefined,
  };

  constructor() {
    super();

    this.state = {
      scriptLoaded: false,
    };
  }

  componentDidMount() {
    const {
      getHandbackUrl,
      handbackUrl,
    } = this.props;

    if (!handbackUrl) {
      getHandbackUrl();
    }
  }

  componentDidUpdate(prevProps) {
    const {
      handbackUrl,
    } = this.props;

    if (handbackUrl !== prevProps.handbackUrl) {

      /*
        For running locally, run mock-server and panel UI repos then replace url in loadScript
        with something like this:
        url: 'http://192.168.1.229:3336/js/jl-recommendations-panel.js',
        also change the isClientProd condition in showRecommendations bit of App.jsx
      */

      loadScript({
        url: `${handbackUrl}/recommendations-ui/v2/static/js/jl-recommendations-panel.js`,
        onSuccessCallback: this.onSuccessCallback,
        onErrorCallback: this.onErrorCallback,
      })();
    }
  }

  onSuccessCallback = () => {
    this.setState({
      scriptLoaded: true,
    });
  }

  onErrorCallback = () => {
    this.setState({
      scriptLoaded: false,
    });
  }

  render() {
    const {
      productIds,
      skuIds,
    } = this.props;

    const {
      scriptLoaded,
    } = this.state;

    if (!scriptLoaded) {
      return null;
    }

    return (
      <jl-recommendations-panel
        placement="OSPOrderConfirmation1"
        productId={productIds}
        skuId={skuIds}
        // use this for mock testing: placement="OSPFashion1"
      />
    );
  }
}

export default connect(state => ({
  productIds: state.orderForm.items.map(item => item.productId).join(),
  skuIds: state.orderForm.items.map(item => item.skuId).join(),
  handbackUrl: state.app.handbackUrl,
}), {
  getHandbackUrl,
})(Recommendations);
